module.exports = __webpack_public_path__ + "img/myntra.0ae8894a.png";